import _ from 'lodash'
import { Space, Typography } from 'antd'

import Table from 'components/Table'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function TableOrganization({
  loading = false,
  columns = [],
  dataSource = [],
  selectedRowKeys = [],
  editMode = true,
  scroll = {},
  onSelectRow = () => null,
  disabledNA = false,
}) {
  const { t } = useTranslate()

  return (
    <Styled className="table-organization-component">
      <Table
        loading={loading}
        className="company"
        columns={_.map(columns, (column) => {
          return {
            ...column,
            key: `company_${column.key}`,
          }
        })}
        dataSource={dataSource}
        rowSelection={{
          selectedRowKeys,
          columnTitle: t('Company'),
          columnWidth: 86,
          onSelect: (record, selected) => {
            onSelectRow({ level: 'company', record, selected })
          },
          getCheckboxProps: (record) => {
            let disabled = false
            if (!editMode) {
              disabled = true
            }
            if (disabledNA) {
              if (record?.code === '00000000') {
                disabled = true
              }
            }
            return {
              disabled,
            }
          },
        }}
        pagination={false}
        expandable={{
          expandedRowRender: (record, index, indent, expanded) => {
            return (
              <Space direction="vertical" size={0} style={{ width: '100%' }}>
                <Typography.Text>Group of Company {record.name}</Typography.Text>
                <Table
                  className="group"
                  columns={_.map(columns, (column) => {
                    return {
                      ...column,
                      key: `group_${column.key}`,
                    }
                  })}
                  dataSource={record?.groups}
                  rowSelection={{
                    selectedRowKeys,
                    columnTitle: 'Group',
                    onSelect: (record, selected) => {
                      onSelectRow({ level: 'group', record, selected })
                    },
                    getCheckboxProps: (record) => {
                      let disabled = false
                      if (!editMode) {
                        disabled = true
                      }
                      if (disabledNA) {
                        if (record?.code === '00000000') {
                          disabled = true
                        }
                      }
                      return {
                        disabled,
                      }
                    },
                  }}
                  pagination={false}
                  expandable={{
                    expandedRowRender: (record, index, indent, expanded) => {
                      return (
                        <Space direction="vertical" size={0} style={{ width: '100%' }}>
                          <Typography.Text>BU/SBU of {record.name}</Typography.Text>
                          <Table
                            className="bu"
                            columns={_.map(columns, (column) => {
                              return {
                                ...column,
                                key: `bu_${column.key}`,
                              }
                            })}
                            dataSource={record?.bus}
                            rowSelection={{
                              selectedRowKeys,
                              columnTitle: 'BU/SBU',
                              onSelect: (record, selected) => {
                                onSelectRow({ level: 'bu', record, selected })
                              },
                              getCheckboxProps: (record) => {
                                let disabled = false
                                if (!editMode) {
                                  disabled = true
                                }
                                if (disabledNA) {
                                  if (record?.code === '00000000') {
                                    disabled = true
                                  }
                                }
                                return {
                                  disabled,
                                }
                              },
                            }}
                            pagination={false}
                            expandable={{
                              expandedRowRender: (record, index, indent, expanded) => {
                                return (
                                  <Space direction="vertical" size={0} style={{ width: '100%' }}>
                                    <Typography.Text>Division of {record.name}</Typography.Text>
                                    <Table
                                      className="division"
                                      columns={_.map(columns, (column) => {
                                        return {
                                          ...column,
                                          key: `division_${column.key}`,
                                        }
                                      })}
                                      dataSource={record?.divisions}
                                      rowSelection={{
                                        selectedRowKeys,
                                        columnTitle: 'Division',
                                        onSelect: (record, selected) => {
                                          onSelectRow({ level: 'division', record, selected })
                                        },
                                        getCheckboxProps: (record) => {
                                          let disabled = false
                                          if (!editMode) {
                                            disabled = true
                                          }
                                          if (disabledNA) {
                                            if (record?.code === '00000000') {
                                              disabled = true
                                            }
                                          }
                                          return {
                                            disabled,
                                          }
                                        },
                                      }}
                                      pagination={false}
                                      expandable={{
                                        expandedRowRender: (record, index, indent, expanded) => {
                                          return (
                                            <Space
                                              direction="vertical"
                                              size={0}
                                              style={{ width: '100%' }}
                                            >
                                              <Typography.Text>
                                                Department of {record.name}
                                              </Typography.Text>
                                              <Table
                                                className="department"
                                                columns={_.map(columns, (column) => {
                                                  return {
                                                    ...column,
                                                    key: `department_${column.key}`,
                                                  }
                                                })}
                                                dataSource={record?.departments}
                                                rowSelection={{
                                                  selectedRowKeys,
                                                  columnTitle: 'Department',
                                                  onSelect: (record, selected) => {
                                                    onSelectRow({
                                                      level: 'department',
                                                      record,
                                                      selected,
                                                    })
                                                  },
                                                  getCheckboxProps: (record) => {
                                                    let disabled = false
                                                    if (!editMode) {
                                                      disabled = true
                                                    }
                                                    if (disabledNA) {
                                                      if (record?.code === '00000000') {
                                                        disabled = true
                                                      }
                                                    }
                                                    return {
                                                      disabled,
                                                    }
                                                  },
                                                }}
                                                pagination={false}
                                                expandable={{
                                                  expandedRowRender: (
                                                    record,
                                                    index,
                                                    indent,
                                                    expanded
                                                  ) => {
                                                    return (
                                                      <Space
                                                        direction="vertical"
                                                        size={0}
                                                        style={{ width: '100%' }}
                                                      >
                                                        <Typography.Text>
                                                          Section of {record.name}
                                                        </Typography.Text>
                                                        <Table
                                                          className="section"
                                                          columns={_.map(columns, (column) => {
                                                            return {
                                                              ...column,
                                                              key: `section_${column.key}`,
                                                            }
                                                          })}
                                                          dataSource={record?.sections}
                                                          rowSelection={{
                                                            selectedRowKeys,
                                                            columnTitle: 'Section',
                                                            onSelect: (record, selected) => {
                                                              onSelectRow({
                                                                level: 'section',
                                                                record,
                                                                selected,
                                                              })
                                                            },
                                                            getCheckboxProps: (record) => {
                                                              let disabled = false
                                                              if (!editMode) {
                                                                disabled = true
                                                              }
                                                              if (disabledNA) {
                                                                if (record?.code === '00000000') {
                                                                  disabled = true
                                                                }
                                                              }
                                                              return {
                                                                disabled,
                                                              }
                                                            },
                                                          }}
                                                          pagination={false}
                                                        />
                                                      </Space>
                                                    )
                                                  },
                                                }}
                                              />
                                            </Space>
                                          )
                                        },
                                      }}
                                    />
                                  </Space>
                                )
                              },
                            }}
                          />
                        </Space>
                      )
                    },
                  }}
                />
              </Space>
            )
          },
        }}
        scroll={scroll}
      />
    </Styled>
  )
}
